import { createAction, props } from '@ngrx/store';
import { RealEstateObject } from '@immosky/types';

export enum SearchResultActions {
  Set = '[Results] Set Real Estate Objects',
  SetInitialPageIndex = '[Results] Set initial Page Index',
  SetPageIndex = '[Results] Set Page Index',
}

export const setRealEstateObjects = createAction(
  SearchResultActions.Set,
  props<{ objects: RealEstateObject[] }>()
);

export const setPageIndex = createAction(
  SearchResultActions.SetPageIndex,
  props<{ pageIndex: number }>()
);

export const setInitialPageIndex = createAction(
  SearchResultActions.SetInitialPageIndex,
  props<{ pageIndex: number }>()
);
